export const NO_INDEX_DIRECTIVE = "noindex, nofollow";
export const CANONICAL_ORIGIN = "https://www.diality.com";

/** The current preprod hostname runs the prod environment; its public pages are indexable. */
export function publicSiteIsIndexable(): boolean {
  return process.env.ENVIRONMENT === "prod";
}

export function isAdminPath(pathname: string): boolean {
  return pathname === "/admin" || pathname.startsWith("/admin/");
}

export function robotsTxt(indexable: boolean): string {
  return indexable
    ? `User-agent: *\nAllow: /\nDisallow: /admin$\nDisallow: /admin?\nDisallow: /admin/\n\nSitemap: ${CANONICAL_ORIGIN}/sitemap.xml\n`
    : "User-agent: *\nDisallow: /\n";
}
